import styled, { css } from "styled-components";

import { focusOutline } from "core/links";
import { easingSeconds } from "core/animation";

export const ImageContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;

    ${({ as }) =>
        as === "a" &&
        css`
            transition: all ${easingSeconds};

            &:focus {
                ${focusOutline}
            }
        `}
`;

export const Image = styled.span.attrs(({ source }) => ({
    role: "img",
    style: {
        backgroundImage: `url(${source})`
    }
}))`
    display: block;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: ${({ backgroundSize }) =>
        backgroundSize ? backgroundSize : "100% auto"};
    background-position: ${({ backgroundPosition }) =>
        backgroundPosition ? backgroundPosition : "center center"};
`;

export const PlaceholderImage = styled.img.attrs(({ source }) => ({
    style: {
        backgroundImage: `url(${source})`
    }
}))`
    vertical-align: bottom;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: ${({ backgroundSize }) =>
        backgroundSize ? backgroundSize : "100% auto"};
    background-position: ${({ backgroundPosition }) =>
        backgroundPosition ? backgroundPosition : "bottom center"};
`;
